import * as React from "react";

export const isEllipsisActive = (target) => {
    return target.current && target.current.offsetWidth < target.current.scrollWidth;
};

export const useEllipsisActive = (target) => {
    const [popup, setPopup] = React.useState({ show: false });

    React.useEffect(() => {
        setPopup({ show: isEllipsisActive(target) });
    }, []);

    return popup;
}
